import { PermissionDto } from "@admin_api/models/permission-dto";
import { RoleDetailsDto } from "@admin_api/models/role-details-dto";

export class RoleState {
    loading = false;
    error = null;
    role: RoleDetailsDto = null;
    permissionList: PermissionDto[] = null;
}
